import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import EnrollmentListShell from "../components/EnrollmentListShell";
import FiltersInlineSlot from "../components/FiltersInlineSlot";
import EnrolledGroupRow from "../components/EnrolledGroupRow";
import { useEnrolledGroupsList } from "../hooks/useEnrolledGroupsList";
import {
  buildEnrollTypeOptions,
  buildGroupTypeOptions,
} from "../config/filterOptions";

const PAGE_SIZE = 10;

interface EnrolledGroupsTabProps {
  corporateId: string | number;
  objectId: number;
}

const EnrolledGroupsTab: React.FC<EnrolledGroupsTabProps> = ({
  corporateId,
  objectId,
}) => {
  const { t } = useTranslation("users-and-groups");
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [groupType, setGroupType] = useState("");
  const [enrollmentType, setEnrollmentType] = useState("");

  const { items, totalItems, totalPages, isLoading } = useEnrolledGroupsList({
    corporateId,
    objectId,
    page,
    pageSize: PAGE_SIZE,
    search: search || undefined,
    groupType: groupType || undefined,
    enrollmentType: enrollmentType || undefined,
  });

  return (
    <EnrollmentListShell
      search={search}
      onSearchSubmit={(v) => {
        setSearch(v);
        setPage(1);
      }}
      filtersSlot={
        <FiltersInlineSlot
          filters={[
            {
              id: "enrolled-groups-status",
              label: String(t("filters.status")),
              value: groupType,
              options: buildGroupTypeOptions(t),
              onChange: (v) => {
                setGroupType(v);
                setPage(1);
              },
            },
            {
              id: "enrolled-groups-type",
              label: String(t("filters.type")),
              value: enrollmentType,
              options: buildEnrollTypeOptions(t),
              onChange: (v) => {
                setEnrollmentType(v);
                setPage(1);
              },
            },
          ]}
        />
      }
      isLoading={isLoading}
      isEmpty={items.length === 0}
      emptyLabel={String(t("empty.enrolled-groups"))}
      page={page}
      pageSize={PAGE_SIZE}
      totalItems={totalItems}
      totalPages={totalPages}
      onPageChange={setPage}
    >
      {items.map((group) => (
        <EnrolledGroupRow
          key={group.id}
          group={group}
          onGoToGroup={(g) => {
            // TODO: navigare al detail del gruppo
            console.log("[enrolled-groups] go to group", g);
          }}
        />
      ))}
    </EnrollmentListShell>
  );
};

export default EnrolledGroupsTab;
